// extracted by mini-css-extract-plugin
module.exports = {"box":"ConfigLists_box__3TAvu"};